import { TInvestmentProductDetails } from "../CreateInvestmentProduct";

/**
 * What a live fund will not let you change, and why.
 *
 * Customers have already subscribed against these, so changing one would
 * rewrite the terms of an investment somebody already holds. The reason is
 * the useful part: a disabled field with no explanation reads as a bug, which
 * is how this screen behaved before.
 */
export const ACTIVE_PRODUCT_LOCKS = {
  name: "Named on every existing subscription.",
  productTypeId: "Changing it would move live plans to another product.",
  startDate: "Already passed.",
  objective: "Published to customers who already subscribed.",
  issuers: "Published to customers who already subscribed.",
  targetInvestors: "Published to customers who already subscribed.",
  description: "Published to customers who already subscribed.",
} as const;

export const ACTIVE_DETAIL_LOCKS: Partial<
  Record<keyof TInvestmentProductDetails, string>
> = {
  coreBankingTenantId: "Bound to the accounts already opened.",
  coreBankingProductId: "Bound to the accounts already opened.",
  depositType: "Bound to the accounts already opened.",
  externalWalletProvider: "Bound to the accounts already opened.",
};
